import { companyList } from '@/services/api-v3/company';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.CompanyPayloadDto[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async () => {
    const res = await companyList({ pageSize: -1, filter: JSON.stringify({ status: 2 }) });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.CompanyPayloadDto) => ({
          ...pre,
          [curr.id]: curr.companyName,
        }),
        {},
      ),
    );
    setValueOptions(
      res.data?.map((item: API.CompanyPayloadDto) => ({ value: item.id, label: item.companyName })),
    );
  };
  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
